import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { PATH_APP } from "../paths";
import { ApplicationWrapper } from "./style";
import ApplicationDashboard from "@/views/Application/Dashboard";
import ApplicationSetting from "@/views/Application/Setting";
import Sidebar from "@/views/Layout/Sidebar";
import { MENU_ITEMS } from "@/views/Layout/Sidebar/type";
import { useTranslation } from "react-i18next";

export default function ApplicationRouter() {
	const { i18n } = useTranslation();
	const [menuItemNumber, setMenuItemNumber] = React.useState(
		i18n.language === "ko" ? 0 : 1,
	);
	useEffect(() => {
		switch (i18n.language) {
			case "ko":
				setMenuItemNumber(0);
				break;
			default:
				setMenuItemNumber(1);
		}
	}, [i18n.language]);
	return (
		<ApplicationWrapper>
			<Sidebar
				title="APPLICATION"
				menuItem={MENU_ITEMS[menuItemNumber].application}
			/>
			<Switch>
				<Route
					exact={true}
					path={PATH_APP.application.dashboard}
					component={ApplicationDashboard}
				/>
				<Route
					exact={true}
					path={PATH_APP.application.setting}
					component={ApplicationSetting}
				/>
			</Switch>
		</ApplicationWrapper>
	);
}
